import { computed, Injectable, signal } from '@angular/core';
import { DeratedCurrentCalculationDto, DesignCurrentDto, ImpedanceDto, VoltageDropDto } from '../../core/mceapi.client.generated';

@Injectable()
export class CableCalculationsStore {

  // --- Design Current ---
  readonly designCurrent = signal<DesignCurrentDto | undefined>(undefined);

  // --- Capacity ---
  readonly capacity = signal<DeratedCurrentCalculationDto | undefined>(undefined);
  readonly conductorTemperature = computed(() =>
    this.capacity()?.conductorTemperature?.conductorTemperature
  );

  // --- Impedance (depends on conductorTemperature) ---
  readonly impedance = signal<ImpedanceDto | undefined>(undefined);

  // --- Voltage Drop (depends on impedance) ---
  readonly voltageDrop = signal<VoltageDropDto | undefined>(undefined);

  // --- Setters ---
  setDesignCurrent(value: DesignCurrentDto | undefined) { this.designCurrent.set(value); }

  setCapacity(value: DeratedCurrentCalculationDto | undefined) {
    this.capacity.set(value);
    // downstream results are invalidated when capacity changes
   // this.impedance.set(undefined);
   // this.voltageDrop.set(undefined);
  }

  setImpedance(value: ImpedanceDto | undefined) {
    this.impedance.set(value);
   // this.voltageDrop.set(undefined);  // invalidate downstream
  }

  setVoltageDrop(value: VoltageDropDto | undefined) {
    this.voltageDrop.set(value);
  }
}
